export const oneDayInMs = 1000 * 60 * 60 * 24;
